import React from 'react'

const Loading = () => {
  return (
    <h2>Loading...</h2>
  )
}

export default Loading
